import { getLevel2 } from './levels';
import { ClickTrackingInfo } from 'api/Tracking/Tracking';

enum ACTIONS_TYPES {
  ACTION = 'action',
  NAVIGATION = 'navigation',
  EXIT = 'exit',
  DOWNLOAD = 'download',
}

export const TRACKING_CLICKS: { [k: string]: () => ClickTrackingInfo } = {
  CONNEXION: () => ({
    name: 'ConnexionConfirmation::depot',
    level2: getLevel2(),
    type: ACTIONS_TYPES.ACTION,
  }),
  INSCRIPTION: () => ({
    name: 'InscriptionConfirmation::depot',
    level2: getLevel2(),
    type: ACTIONS_TYPES.ACTION,
  }),
  RESET_PASSWORD: () => ({
    name: 'PasswordOublieConfirmation::depot',
    level2: getLevel2(),
    type: ACTIONS_TYPES.ACTION,
  }),
  VERTICAL_CHOICE: () => ({
    name: 'VerticalChoiceConfirmation::depot',
    level2: getLevel2(),
    type: ACTIONS_TYPES.ACTION,
  }),
};
